import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../../services/authentication/authContext';
import { Header } from '../landingpage/sections/Header';
import { useBookDemo } from '../../../hooks/useBookDemo';

export default function Signup() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { user, loading } = useAuth();
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const openBookDemo = useBookDemo('signup');

  useEffect(() => {
    if (!loading && user) {
      navigate('/dashboard');
    }
  }, [user, loading, navigate]);

  // Public signup is intentionally closed; Enter must not bypass the disabled button.
  const handleSubmit = (e: React.FormEvent) => e.preventDefault();

  return (
    <>
      <div className="relative overflow-hidden min-h-screen bg-landingPageBG text-white dark:bg-landingPageBG dark:text-white">
        <Header />
        <div className="flex justify-center px-5 pt-20">
          <div className="relative z-10 w-full max-w-md h-fit">
            <div className="rounded-2xl border border-white/10 p-8 bg-white/5 backdrop-blur-sm dark:border-white/10 dark:bg-white/5">
              <h1 className="text-2xl font-semibold text-white mb-6 dark:text-white">{t('auth.signUp')}</h1>

              <div className="mb-6 p-4 rounded-xl bg-accent/10 border border-accent/30 dark:bg-accent/10 dark:border-accent/30">
                <p className="text-center text-white/90 text-sm mb-3 dark:text-white/90">
                  {t('auth.onboardingMessage')}
                </p>
                <button
                  onClick={openBookDemo}
                  className="w-full px-4 py-2 text-sm font-semibold bg-accent text-white hover:bg-accent/90 rounded-xl transition dark:bg-accent dark:text-white dark:hover:bg-accent/90"
                >
                  {t('auth.bookDemo')}
                </button>
              </div>

              <form onSubmit={handleSubmit} className="space-y-4">
                <div>
                  <input
                    type="text"
                    placeholder={t('managedSignup.name')}
                    value={name}
                    required
                    onChange={e => setName(e.target.value)}
                    className="w-full px-4 py-3 border border-white/20 rounded-xl bg-white/10 text-white placeholder-white/50 focus:outline-none focus:ring-2 focus:ring-accent focus:border-transparent dark:border-white/20 dark:bg-white/10 dark:text-white dark:placeholder-white/50 dark:focus:ring-accent dark:focus:border-transparent"
                  />
                </div>
                <div>
                  <input
                    type="email"
                    placeholder={t('managedSignup.email')}
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    className="w-full px-4 py-3 border border-white/20 rounded-xl bg-white/10 text-white placeholder-white/50 focus:outline-none focus:ring-2 focus:ring-accent focus:border-transparent dark:border-white/20 dark:bg-white/10 dark:text-white dark:placeholder-white/50 dark:focus:ring-accent dark:focus:border-transparent"
                  />
                </div>
                <div>
                  <input
                    type="password"
                    placeholder={t('managedSignup.password')}
                    value={password}
                    onChange={e => setPassword(e.target.value)}
                    className="w-full px-4 py-3 border border-white/20 rounded-xl bg-white/10 text-white placeholder-white/50 focus:outline-none focus:ring-2 focus:ring-accent focus:border-transparent dark:border-white/20 dark:bg-white/10 dark:text-white dark:placeholder-white/50 dark:focus:ring-accent dark:focus:border-transparent"
                  />
                </div>
                <button
                  type="submit"
                  disabled
                  className="w-full px-6 py-3 text-base font-semibold bg-accent text-white hover:bg-accent/90 rounded-2xl transition disabled:opacity-50 disabled:cursor-not-allowed dark:bg-accent dark:text-white dark:hover:bg-accent/90"
                >
                  {t('auth.signUp')}
                </button>
              </form>

              <p className="mt-6 text-center text-sm text-white/70 dark:text-white/70">
                {t('auth.alreadyHaveAccount')}{' '}
                <a href="/login" className="text-white font-medium hover:underline dark:text-white">
                  {t('auth.login')}
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}